__webpack_require__.p = "https://ads.wpcdn.pl/release-v1.445.0/public-desktop/";